import { createSlice } from "@reduxjs/toolkit"

const initialStateFiltrosFacturas = {
  idLiquidacionWeb: -1,
  fechaFacturaInicio: "",
  fechaFacturaFin: "",
  fechaAltaInicio: "",
  fechaAltaFin: "",
  nroFactura: "",
  idEstadoLiquidacionWeb: -1,
  idAnalista: -1,
  idJuicio: -1,
  idTipoFactura: -1,
  monImporteFacDesde: "",
  monImporteFacHasta: "",
  idPrestador: "",
  cuitLetrado: "",
  etapaFacturacion: "",
  cargados: false,
  filtroRapido: ""
};

export const filtrosFacturasSlice = createSlice({
  name: "filtrosFacturas",
  initialState: initialStateFiltrosFacturas,
  reducers: {
    addFiltrosFacturas: (state, action) => {
      const { idLiquidacionWeb, fechaFacturaInicio, fechaFacturaFin, fechaAltaInicio, fechaAltaFin, nroFactura, idEstadoLiquidacionWeb, idAnalista, idTipoFactura, monImporteFacDesde, monImporteFacHasta, idPrestador, cuitLetrado, etapaFacturacion, idJuicio } = action.payload
      state.idLiquidacionWeb = idLiquidacionWeb
      state.fechaFacturaInicio = fechaFacturaInicio
      state.fechaFacturaFin = fechaFacturaFin
      state.fechaAltaInicio = fechaAltaInicio
      state.fechaAltaFin = fechaAltaFin
      state.nroFactura = nroFactura
      state.idEstadoLiquidacionWeb = idEstadoLiquidacionWeb
      state.idAnalista = idAnalista
      state.idJuicio = idJuicio
      state.idTipoFactura = idTipoFactura
      state.monImporteFacDesde = monImporteFacDesde
      state.monImporteFacHasta = monImporteFacHasta
      state.idPrestador = idPrestador
      state.cuitLetrado = cuitLetrado
      state.etapaFacturacion = etapaFacturacion
    },
    resetFiltrosFacturas: (state) => {
      state.idLiquidacionWeb = initialStateFiltrosFacturas.idLiquidacionWeb
      state.fechaFacturaInicio = initialStateFiltrosFacturas.fechaFacturaInicio
      state.fechaFacturafin = initialStateFiltrosFacturas.fechaFacturafin
      state.fechaAltaInicio = initialStateFiltrosFacturas.fechaAltaInicio
      state.fechaAltaFin = initialStateFiltrosFacturas.fechaAltaFin
      state.nroFactura = initialStateFiltrosFacturas.nroFactura
      state.idEstadoLiquidacionWeb = initialStateFiltrosFacturas.idEstadoLiquidacionWeb
      state.idAnalista = initialStateFiltrosFacturas.idAnalista
      state.idTipoFactura = initialStateFiltrosFacturas.idTipoFactura
      state.monImporteFacDesde = initialStateFiltrosFacturas.monImporteFacDesde
      state.monImporteFacHasta = initialStateFiltrosFacturas.monImporteFacHasta
      state.idPrestador = initialStateFiltrosFacturas.idPrestador
      state.cuitLetrado = initialStateFiltrosFacturas.cuitLetrado
      state.cargados = initialStateFiltrosFacturas.cargados
      state.filtroRapido = initialStateFiltrosFacturas.filtroRapido
      state.etapaFacturacion = initialStateFiltrosFacturas.etapaFacturacion
      state.idJuicio = initialStateFiltrosFacturas.idJuicio
    },
    setFiltrosCargados: (state, action) => {
      state.cargados = action.payload
    },
    addFiltroRapidoFacturas: (state, action) => {
      state.filtroRapido = action.payload
    },
  }
});

export const { addFiltrosFacturas, resetFiltrosFacturas, setFiltrosCargados, addFiltroRapidoFacturas } = filtrosFacturasSlice.actions
export default filtrosFacturasSlice.reducer
